import template from './stSelect.html';
import controller from './stSelect.controller';

let stSelectComponent = {
  restrict: 'E',
  bindings: {
      items: '=',
      getTransfers: '&'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default stSelectComponent;



// WEBPACK FOOTER //
// ./client/app/common/stSelect/stSelect.component.js